module.exports = __webpack_public_path__ + "static/media/refund.0b9ce2ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/ssp2/refund.svg
// module id = 499
// module chunks = 0